export default __webpack_public_path__ + "static/media/retail.8cbba5cf.jpg";